// jshint esversion: 8
const setDistinctive = (state, prop, val) => state.distinctive[prop] = val;

export default {
  SET_DISTINCTIVE: (state, payload) => setDistinctive(state, payload.prop, payload.val)
};
